import { render, staticRenderFns } from "./FilterPexGroup.vue?vue&type=template&id=502bedc3&"
import script from "./FilterPexGroup.vue?vue&type=script&lang=js&"
export * from "./FilterPexGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports